// Options

export const VUE_API = {
  general: '',
  static: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PUBLIC_PATH : '/'
}

export const VUE_MEDIAQUERY = {
  variables: {
    xs: 0,
    sm: '575px',
    md: '767px',
    lg: '991px',
    xl: '1251px'
  }
}
